import { render, staticRenderFns } from "./AddParameters.vue?vue&type=template&id=367daac1&scoped=true"
import script from "./AddParameters.vue?vue&type=script&lang=js"
export * from "./AddParameters.vue?vue&type=script&lang=js"
import style0 from "./AddParameters.vue?vue&type=style&index=0&id=367daac1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367daac1",
  null
  
)

export default component.exports